import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CiCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/CiCircleTwoTone";
import AntdIcon from "../components/AntdIcon";
var CiCircleTwoTone = function CiCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CiCircleTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CiCircleTwoTone.displayName = 'CiCircleTwoTone';
}
export default /*#__PURE__*/React.forwardRef(CiCircleTwoTone);